<template>
  <div class="verify-otp">
    <Message v-show="message.fieldName==='resendOTP'" :message="message" />
    <h1 class="verify-otp__heading">
      Please enter the OTP sent to your mobile no.
      <br />
      {{signupMobile}}
    </h1>
    <form @submit.prevent="submitOTP" class="verify-otp__form" novalidate autocomplete="off">
      <div class="verify-otp__form__otp" id="otp">
        <input
          class="verify-otp__form__otp__number-field"
          type="tel"
          size="1"
          name="0"
          v-focus
          minlength="1"
          maxlength="1"
          pattern="[0-9]"
          required
          v-model="otp[0]"
          v-numericOnly
        />
        <input
          class="verify-otp__form__otp__number-field"
          type="tel"
          size="1"
          name="1"
          minlength="1"
          maxlength="1"
          pattern="[0-9]"
          required
          v-model="otp[1]"
          v-numericOnly
        />
        <input
          class="verify-otp__form__otp__number-field"
          type="tel"
          size="1"
          name="2"
          minlength="1"
          maxlength="1"
          pattern="[0-9]"
          required
          v-model="otp[2]"
          v-numericOnly
        />
        <input
          class="verify-otp__form__otp__number-field"
          type="tel"
          size="1"
          name="3"
          minlength="1"
          maxlength="1"
          pattern="[0-9]"
          required
          v-model="otp[3]"
          v-numericOnly
        />
        <Message v-show="message.fieldName==='otp'" :message="message" />
      </div>
      <label
        for
        class="verify-otp__form__label--alternate verify-otp__form__label--alternate--text-center"
      >
        <template v-if="timer===0">
          Didn't receive OTP?
          <button
            id="resend-button"
            class="verify-otp__form__label--alternate__link"
            type="button"
            @click="resendOTP"
          >Resend</button>
        </template>
        <template v-else>
          <span>You can resend in</span>
          <span class="verify-otp__form__label--alternate--timer-number">{{timer}}s</span>
        </template>
      </label>
      <template v-if="message && message.showModal">
        <Overlay @on-click="unsetErrors" />
        <ConfirmationModal :message="message">
          <template v-slot:close-button>
            <button class="close-button" type="button" @click="unsetErrors">
              <img src="../../static/images/cross.svg" alt="Close Button" />
            </button>
          </template>
          <ActionButton
            v-slot:default
            v-for="(action,index) in message.actions"
            :key="index"
            @click="action.method"
            :title="action.title"
            :className="action.isPrimary?'':'action-button--alternate'"
            type="button"
          />
        </ConfirmationModal>
      </template>

      <ActionButton :disabled="otp.length<4" title="Continue" />
    </form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ActionButton from "../components/ActionButton";
import Message from "../components/SignupInfoMessage";
import Overlay from "../components/Overlay";
import ConfirmationModal from "../components/ConfirmationModal";
export default {
  name: "Sign-Up-Verify-OTP",
  data() {
    return {
      otp: [],
      params: { otp: undefined },
      fieldName: 0,
      message: {
        value: undefined,
        type: undefined,
        className: undefined,
        fieldName: undefined
      },
      timer: 30,
      timerInterval: undefined,
      currentFieldName: undefined
    };
  },
  watch: {
    otp(val) {
      if (
        !document.activeElement.value &&
        document.activeElement.previousElementSibling
      ) {
        document.activeElement.previousElementSibling.focus();
      } else if (
        document.activeElement.value &&
        document.activeElement.nextElementSibling
      ) {
        document.activeElement.nextElementSibling.focus();
      }
      this.params.otp = this.otp.join("");
      // this.fieldName = currentFieldName;
    }
  },
  components: { ActionButton, Message, Overlay, ConfirmationModal },
  computed: {
    ...mapGetters(["loggedIn", "signupMobile"])
  },
  mounted() {
    this.timerInterval = setInterval(() => {
      if (this.timer > 0) {
        this.timer -= 1;
      }
    }, 1000);
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SCREEN",
      propertyName: "SCREEN_NAME",
      propertyValue: "VERIFY_MOBILE_NO"
    });
  },
  methods: {
    submitOTP() {
      this.$store
        .dispatch("generateRecaptcha", { action: "mobile" })
        .then(token => {
          this.params.recaptcha = token;
          this.$store
            .dispatch(
              this.$route.name === "Login Verify OTP"
                ? "loginVerify"
                : "signupVerify",
              this.params
            )
            .then(response => {
              window.clearInterval(this.timerInterval);
              this.$store.dispatch("storeMixpanelEvent", {
                eventName: "OTP_ENTERED",
                propertyName: "VIEW",
                propertyValue:
                  this.$route.name === "Login Verify OTP" ? "LOGIN" : "SIGNUP"
              });
              this.$store.commit("SET_SIGNUP_STATUS", {
                userSignupStatus: response.signupStatus
              });
              if (response.email) {
                this.$store.commit("PRESET_EMAIL", response.email);
                this.$store.dispatch("setUserEmail", response.email);
              } else {
                this.$store.commit("PRESET_EMAIL", undefined);
              }
              this.$store
                .dispatch("resolveSignupRoute", response.signupStatus)
                .then(response => {
                  if (response.routeName === "Loading") {
                    this.$store.dispatch("getUser").then(response => {
                      response.version === "epaylaterv2"
                        ? this.$router.push({
                            name: "Dashboard"
                          })
                        : this.$router.push({
                            name: "Home"
                          });
                      this.$store.commit("setLoginState", true);
                    });
                  } else {
                    if (
                      this.$route.name === "Login Verify OTP" &&
                      this.$route.query.redirect
                    ) {
                      this.$router.push({ path: this.$route.query.redirect });
                    } else {
                      this.$router.push({ name: response.routeName });
                    }
                  }
                })
                .catch(() => this.$router.push({ name: "Signup" }));
            })
            .catch(err => {
              if (err.status === 401) {
                this.$router.push({ name: "Signup" });
              } else {
                this.otp = [];
                this.params.otp = "";
                this.message = {
                  type: "warning",
                  className: "message--error",
                  fieldName: "generic",
                  value: err.data.message,
                  showModal: true,
                  actions: [
                    {
                      title: "Ok",
                      method: () => this.unsetErrors(),
                      isPrimary: true
                    }
                  ]
                };
              }
            });
        });
    },
    resendOTP() {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "RESEND_OTP",
        propertyName: "SCREEN",
        propertyValue:
          this.$route.name === "Login Verify OTP" ? "LOGIN" : "SIGNUP"
      });
      this.$store
        .dispatch("mobileResend")
        .then(response => {
          this.timer = 30;
          this.message = {
            type: "success",
            className: "message--success",
            fieldName: "resendOTP",
            value: "OTP has been resent to your mobile number."
          };
        })
        .catch(err => {
          if (err.status === 401) {
            this.$router.push({ name: "Signup" });
          } else {
            this.message = {
              type: "warning",
              className: "message--error",
              fieldName: "generic",
              value: err.data.message,
              showModal: true,
              actions: [
                {
                  title: "Ok",
                  method: () => this.unsetErrors(),
                  isPrimary: true
                }
              ]
            };
          }
        });
    },
    unsetErrors() {
      this.message = {};
    }
  }
};
</script>
<style lang="scss" scoped>
.verify-otp {
  width: 100%;
  &__back {
    display: none;
    @media only screen and (min-width: 640px) {
      background: transparent;
      border: solid 0.05rem rgba(0, 0, 0, 0.1);
      width: 4rem;
      height: 4rem;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      border-radius: 0.4rem;
    }
    svg {
      height: 2.7rem;
    }
  }
  &__heading {
    font-size: 1.6rem;
    color: var(--gray-2);
    text-align: center;
    margin-top: 3rem;
    @media only screen and (min-width: 640px) {
      font-size: 2.2rem;
    }
  }
  &__form {
    &__otp {
      margin-bottom: 3.4rem;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      &__number-field {
        border: none;
        border-bottom: solid 0.06rem var(--gray-4);
        margin: 0.75rem;
        text-align: center;
        font-size: 1.6rem;
        width: 4rem;
        @media only screen and (min-width: 640px) {
          font-size: 1.8rem;
        }
        &:focus {
          border-bottom: 0.1rem solid var(--primary-color);
          outline: none;
        }
      }
    }
    &__label {
      &--alternate {
        font-size: 1.4rem;
        color: var(--gray-3);
        margin-bottom: 1.6rem;
        align-items: center;
        font-weight: 300;
        display: grid;
        grid-template-columns: auto 1fr;
        grid-template-rows: 1fr 1fr;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        &--text-center {
          display: block;
          text-align: center;
        }
        &--timer-number {
          color: var(--primary-color);
          font-size: 2rem;
          width: 3rem;
          display: inline-block;
          text-align: center;
        }
        &__link {
          color: var(--primary-color);
          text-decoration: none;
          background: transparent;
          box-shadow: none;
          border: none;
          cursor: pointer;
          font-size: 1.4rem;
          &:disabled {
            cursor: default;
            color: var(--gray-3);
          }
        }
      }
    }
  }
}
.message {
  width: 100%;
  justify-content: center;
}
.close-button {
  background: transparent;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SignupVerifyOTP.vue